export const SCORE_CLEF_SPACES = 3;
export const SCORE_TIME_SIGNATURE_SPACES = 2;
export const SCORE_KEY_SIGNATURE_LEAD = 0.8;
export const SCORE_DESKTOP_MARGIN_SPACES = 4;
export const SCORE_MOBILE_MARGIN_SPACES = 1.25;

export function scoreKeySignatureWidth(count: number): number {
  return count > 0 ? SCORE_KEY_SIGNATURE_LEAD + count : 0;
}

/** Header room for a time signature. The default holds one Bravura digit
 *  (~1.8 spaces); each further digit of the longer number (12/8) adds one. */
export function scoreTimeSignatureWidth(timeSig: readonly [number, number] | undefined): number {
  const digits = Math.max(
    1,
    ...(timeSig ?? []).map((n) => String(Math.max(0, Math.trunc(n))).length),
  );
  return SCORE_TIME_SIGNATURE_SPACES + (digits - 1) * 1.8;
}
